import TaitoraMark, { type MarkTone } from "./TaitoraMark";

export type LogoVariant = "product" | "company" | "mark";
export type LogoTone   = "light" | "dark" | "mono";

interface Props {
  variant?: LogoVariant;
  tone?:    LogoTone;
  size?:    number | string;
  className?: string;
}

const TEXT_COLOR: Record<LogoTone, string> = {
  light: "#F6F2EA",
  dark:  "#111318",
  mono:  "currentColor",
};

export default function TaitoraLogo({ variant = "product", tone = "dark", size = 32, className }: Props) {
  const markTone = tone as MarkTone;
  const textColor = TEXT_COLOR[tone];
  const markSize = typeof size === "number" ? size : parseInt(size as string, 10) || 32;

  if (variant === "mark") {
    return <TaitoraMark size={markSize} tone={markTone} className={className} />;
  }

  const label   = variant === "product" ? "taitora.ai" : "Taitora Labs";
  const fontSize = Math.round(markSize * 0.55);

  return (
    <div className={`flex items-center gap-3 ${className ?? ""}`}>
      <TaitoraMark size={markSize} tone={markTone} />
      <span
        style={{
          fontFamily: "Inter, system-ui, sans-serif",
          fontWeight: 700,
          fontSize,
          letterSpacing: "-0.02em",
          color: textColor,
          lineHeight: 1,
          userSelect: "none",
        }}
      >
        {variant === "product" ? (
          <>taitora<span style={{ opacity: 0.7 }}>.ai</span></>
        ) : (
          label
        )}
      </span>
    </div>
  );
}
